import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { envIsSweden } from '@/constants/constants';

const useIsPayNPlayMarket = (): boolean => {
  const locale = useSelector(selectLocale);

  return useMemo(() => {
    return envIsSweden() || ['fi', 'fi-en'].includes(locale);
  }, [locale]);
};

export default useIsPayNPlayMarket;
